import { PreRegistrationMain } from '@/_features/motoboys/pre-registration';

function PreRegistration() {
  return (
    <div className="container">
      <PreRegistrationMain />
    </div>
  );
}

export default PreRegistration;
